import { Grid, Typography } from '@mui/material'
import React from 'react'
import useStyles from '@styles/pages/404/style'
import { ButtonComponent } from 'src/components/shared/atoms'
import { useRouter } from 'next/router'

const Custom404 = () => {
  const { classes } = useStyles()
  const router = useRouter()
  return (
    <Grid className={classes.root}>
      <Grid className={classes.contentContainer}>
        <Typography className={classes.heading}>Error 404</Typography>
        <Typography className={classes.subHeading}>
          <span>Sorry!</span>{' '}
          <span>
            We can&apos;t seem to find the page you&apos;re looking for
          </span>
        </Typography>
        <Grid className={classes.btnContainer}>
          <ButtonComponent
            text="HOME"
            type="text"
            gradient
            className={classes.button}
            onClick={() => router.push('/')}
            wrapperClass={classes.gradientWrapper}
          />
          <ButtonComponent
            text="CONTACT US"
            type="text"
            gradient
            className={classes.button}
            onClick={() => router.push('/contact-us')}
            wrapperClass={classes.gradientWrapper}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Custom404
